<!-- Bid Creation Modal -->
<div
  class="modal-overlay bid-creation-modal"
  [class.active]="isActive || (isTransactionActive && (txTrackingSvc.txModalActive$ | async))">

  <div class="modal">
    <button 
      class="close-modal" 
      *ngIf="!(isTransactionActive && (txTrackingSvc.txModalActive$ | async))" 
      (click)="closeModal()">x</button>
    <button 
      class="close-modal" 
      *ngIf="isTransactionActive && (txTrackingSvc.txModalActive$ | async)" 
      (click)="closeTransactionTracking()">x</button>
    
    <!-- Fixed Modal Header -->
    <div class="modal-header">
      <h2>{{ getModalTitle() }}</h2>
      
      <!-- Breadcrumb Stepper -->
      <div class="stepper-breadcrumb">
        <div class="step" [class.active]="currentStep === 'check'" [class.completed]="currentStep === 'transfer' || currentStep === 'sign' || currentStep === 'amount' || currentStep === 'publish'">
          <span class="step-number">1</span>
          <span class="step-label">{{ step1Label }}</span>
        </div>
        <div class="step-separator" [class.completed]="currentStep === 'transfer' || currentStep === 'sign' || currentStep === 'publish'"></div>
        <div class="step" [class.active]="currentStep === 'transfer' || currentStep === 'amount'" [class.completed]="currentStep === 'sign' || currentStep === 'publish'">
          <span class="step-number">2</span>
          <span class="step-label">Transfer funds</span>
        </div>
        <div class="step-separator" [class.completed]="currentStep === 'sign' || currentStep === 'publish'"></div>
        <div class="step" [class.active]="currentStep === 'sign'" [class.completed]="currentStep === 'publish'">
          <span class="step-number">3</span>
          <span class="step-label">{{ step3Label }}</span>
        </div>
        <div class="step-separator" [class.completed]="currentStep === 'publish'"></div>
        <div class="step" [class.active]="currentStep === 'publish'">
          <span class="step-number">4</span>
          <span class="step-label">Publish</span>
        </div>
      </div>
    </div>

    <!-- Transaction Tracking Message -->
    <ng-container *ngIf="isTransactionActive && (txTrackingSvc.txModalActive$ | async)">
      <div class="transaction-status">
        <ng-container *ngFor="let status of txTrackingSvc.txStatusArray; let i = index">
          <ng-container *ngIf="status.active">
            <h3>
              <img
                src="/assets/loader-{{ themeSvc.theme$ | async }}.gif"
                width="20" height="20"
                *ngIf="i === 0 || i === 1"
              />
              {{ status.title }}
            </h3>
            <span class="p-wrapper" [innerHTML]="status.message || ''"></span>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>

    <!-- Step 1: Type (dual-mode) or Check/Deploy Stash -->
    <ng-container *ngIf="isActive && currentStep === 'check' && !(isTransactionActive && (txTrackingSvc.txModalActive$ | async))">
      <div class="punk-info" style="min-height: 16rem">
        <div class="bid-platform-tabs" *ngIf="dualBidPlatformEnabled">
          <button
            type="button"
            class="platform-tab"
            [class.active]="selectedBidPlatform === 'onchain'"
            (click)="selectBidPlatform('onchain')">
            <app-on-chain-bid-label>On-chain</app-on-chain-bid-label>
          </button>
          <button
            type="button"
            class="platform-tab"
            [class.active]="selectedBidPlatform === 'stash'"
            (click)="selectBidPlatform('stash')">
            Stash bid
          </button>
        </div>

        <ng-container *ngIf="isOnChainPlatformSelected">
          <p>
            Place an <app-on-chain-bid-label>on-chain bid</app-on-chain-bid-label>
            for your {{ getBidTypeLabel().toLowerCase() }}.
            Funds are locked in the on-chain escrow contract until you cancel the bid or it is accepted.
          </p>
          <p class="hint">{{ onChainBidEscrowHint }}</p>
        </ng-container>

        <ng-container *ngIf="!isOnChainPlatformSelected">
          <p *ngIf="checkingStash">Checking stash status...</p>
          <div *ngIf="!checkingStash && stashDeployed">
            <p *ngIf="stashUpgradeNeeded && stashOnChainVersion !== null && factoryTargetVersion !== null">
              Your stash must be upgraded from <strong>v{{ stashOnChainVersion }}</strong> to <strong>v{{ factoryTargetVersion }}</strong> before you can continue.
              <a
                [href]="'https://etherscan.io/address/' + stashAddress"
                target="_blank"
                rel="noopener noreferrer"
                class="stash-inline-link"
              >View on Etherscan</a>
            </p>
            <p *ngIf="!stashUpgradeNeeded">
              ✅ Your stash is deployed and ready (<a
                [href]="'https://etherscan.io/address/' + stashAddress"
                target="_blank"
                rel="noopener noreferrer"
              ><app-wallet-address [address]="stashAddress || ''"></app-wallet-address>
              </a>).
            </p>
            <p *ngIf="stashLiquidityLoading">Fetching stash liquidity...</p>
            <ng-container *ngIf="!stashUpgradeNeeded && !stashLiquidityLoading && stashLiquidityTotalEth !== null">
              <p>
                Available liquidity in stash: {{ stashLiquidityTotalEth | number:'1.2-4' }} ETH
                (<a href="javascript:void(0)" (click)="withdrawAvailableEth()">withdraw</a>)
              </p>
            </ng-container>
          </div>
          <p style="text-align: left; font-size: 1.5rem; color: rgba(var(--text-color), 0.5);" *ngIf="environment.collection === 'cryptopunks'">
          Collection bids created on <a href="https://cryptopunks.eth.limo" target="_blank" rel="noopener noreferrer">Cryptopunks.eth.limo</a> are using the official and audited CryptoPunks Stash contract created by <a href="https://x.com/0xQuit" target="_blank" rel="noopener noreferrer">0xQuit</a> from Yuga Labs.
          </p>
          <p style="text-align: left; font-size: 1.5rem; color: rgba(var(--text-color), 0.5);" *ngIf="environment.collection === 'cryptopunks-v1' && !dualBidPlatformEnabled">
          Collection bids created on <a href="https://v1cryptopunks.com" target="_blank" rel="noopener noreferrer">v1cryptopunks.com</a> are using a fork of the Stash contract created by <a href="https://x.com/0xQuit" target="_blank" rel="noopener noreferrer">0xQuit</a> from Yuga Labs.
          </p>
          <p style="text-align: left; font-size: 1.5rem; color: rgba(var(--text-color), 0.5);" *ngIf="environment.collection === 'cryptopunks-v1' && dualBidPlatformEnabled && selectedBidPlatform === 'stash'">
          Stash bids on <a href="https://v1cryptopunks.com" target="_blank" rel="noopener noreferrer">v1cryptopunks.com</a> use a fork of the Stash contract created by <a href="https://x.com/0xQuit" target="_blank" rel="noopener noreferrer">0xQuit</a> from Yuga Labs.
          </p>
          <div *ngIf="!checkingStash && !stashDeployed">
            <p>Your stash is not deployed yet. Deploy it before creating a bid.</p>
          </div>
        </ng-container>
      </div>

      <div class="form-actions form-actions--stash-step" *ngIf="isOnChainPlatformSelected">
        <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
        <button type="button" class="submit" (click)="proceedFromTypeStep()">Continue</button>
      </div>

      <div class="form-actions form-actions--stash-step" *ngIf="!isOnChainPlatformSelected && !checkingStash">
        <button type="button" class="cancel" (click)="closeModal()">Cancel</button>
        <button
          *ngIf="stashUpgradeNeeded"
          type="button"
          class="submit"
          (click)="upgradeStashContract()">
          Upgrade stash
        </button>
        <button
          *ngIf="!stashUpgradeNeeded && stashDeployed"
          type="button"
          class="submit"
          (click)="proceedFromTypeStep()">
          Continue
        </button>
        <button
          *ngIf="!stashUpgradeNeeded && !stashDeployed"
          type="button"
          class="submit"
          (click)="deployStash()">
          Deploy stash
        </button>
      </div>
      <div class="form-actions form-actions--stash-step" *ngIf="!isOnChainPlatformSelected && checkingStash">
        <button type="button" class="cancel form-actions__single" (click)="closeModal()">Cancel</button>
      </div>
    </ng-container>

    <!-- Step 2: Amount Input -->
    <ng-container *ngIf="isActive && currentStep === 'amount' && !(isTransactionActive && (txTrackingSvc.txModalActive$ | async))">
      <div class="punk-info">
        <p>Enter the amount in ETH for your {{ getBidTypeLabel().toLowerCase() }}.</p>
        <ng-container *ngIf="!isOnChainPlatformSelected && stashDeployed && stashAddress">
          <p *ngIf="stashLiquidityLoading" class="stash-balance-info">
            Loading stash balance...
          </p>
          <p *ngIf="!stashLiquidityLoading && stashLiquidityTotalEth !== null" class="stash-balance-info">
            Current stash balance: <strong>{{ stashLiquidityTotalEth | number:'1.4-4' }} ETH</strong>
          </p>
        </ng-container>
      </div>

      <div class="form-group expiry-select" *ngIf="!isOnChainPlatformSelected">
        <label for="bid-expiry">Bid expiry</label>
        <ng-select
          id="bid-expiry"
          name="bidExpiry"
          [items]="collectionBidExpiryOptions"
          bindLabel="label"
          [searchable]="false"
          [clearable]="false"
          placeholder="Select duration"
          [(ngModel)]="collectionBidExpiryModel">
        </ng-select>
      </div>

      <div class="toggle-wrapper toggle-wrapper--inline" *ngIf="!isOnChainPlatformSelected">
        <div class="sales-only-toggle" (click)="onConfidentialToggle()">
          <div class="label" i18n>Confidential</div>
          <div class="toggle" [class.on]="confidential">
            <div></div>
          </div>
        </div>
        <div class="sales-only-toggle send-limited-notification-toggle" *ngIf="confidential" (click)="onSendLimitedNotificationToggle()">
          <div class="label-with-info">
            <div class="label">Send Limited Notification</div>
          </div>
          <div class="toggle" [class.on]="sendLimitedNotification">
            <div></div>
          </div>

          <button
            type="button"
            class="limited-notification-info"
            (click)="stopToggleClick($event)"
            tippy
            [options]="{ content: 'allow sending a notification without mentioning the amount nor the bidder', placement: 'top', theme: 'punks' }"
            aria-label="About limited notification">
            <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24" width="16" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/></svg>
          </button>
        </div>
      </div>

      <div class="toggle-wrapper toggle-wrapper--inline" *ngIf="!isOnChainPlatformSelected && showStashBidProtectionToggle">
        <div class="sales-only-toggle stash-bid-protection-toggle" (click)="onStashBidProtectionToggle()">
          <div class="label" i18n>Legacy bid protection</div>
          <div class="toggle" [class.on]="stashBidProtectionEnabled">
            <div></div>
          </div>
          <button
            type="button"
            class="stash-bid-protection-info"
            (click)="stopToggleClick($event)"
            tippy
            [options]="{ content: 'When enabled, we will attempt to clear competing on-chain legacy bids on punks covered by this stash bid if your bid is the best offer available.', placement: 'top', theme: 'punks' }"
            i18n-aria-label
            aria-label="About legacy bid protection">
            <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24" width="16" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/></svg>
          </button>
        </div>
      </div>

      <div class="toggle-wrapper" *ngIf="!isOnChainPlatformSelected && bidType === 'trait'">
        <div class="sales-only-toggle disguise-bid-toggle" (click)="onDisguiseTraitBidToggle()">
          <div class="label" i18n>Disguise bid</div>
          <button
            type="button"
            class="disguise-bid-info"
            (click)="onDisguiseBidInfoClick($event)"
            i18n-aria-label
            aria-label="About disguise bid">
            <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24" width="16" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/></svg>
          </button>
          <div class="toggle" [class.on]="disguiseTraitBidAsCustom">
            <div></div>
          </div>
        </div>
      </div>

      <div class="toggle-wrapper" *ngIf="!isOnChainPlatformSelected && environment.collection === 'cryptopunks'">
        <div class="sales-only-toggle cryptopunks-app-publish-toggle" [class.disabled]="confidential">
          <div class="label" i18n>Publish bid to <a href="https://www.cryptopunks.app/cryptopunks/bids" class="pink" target="_blank" rel="noopener noreferrer">CryptoPunks.app</a></div>
          <div class="toggle" [class.on]="!confidential">
            <div></div>
          </div>
          <button
            type="button"
            class="cryptopunks-app-publish-info"
            (click)="stopToggleClick($event)"
            tippy
            [options]="{ content: 'When your bid is not confidential, it can be published to CryptoPunks.app after you sign. Confidential bids are not shown on the public CryptoPunks.app orderbook.', placement: 'top', theme: 'punks' }"
            i18n-aria-label
            aria-label="About publishing to CryptoPunks.app">
            <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24" width="16" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/></svg>
          </button>
        </div>
      </div>

      <div class="toggle-wrapper" *ngIf="isOnChainPlatformSelected">
        <div class="sales-only-toggle settlement-reward-toggle" (click)="onOnChainSettlementToggle()">
          <div class="label">Settlement reward for acceptor</div>
          <div class="toggle" [class.on]="showOnChainSettlementReward">
            <div></div>
          </div>
        </div>
      </div>

      <div class="form-group" *ngIf="isOnChainPlatformSelected && showOnChainSettlementReward">
        <label for="onchain-settlement-amount">Settlement reward (Ξ)</label>
        <input
          type="number"
          id="onchain-settlement-amount"
          [(ngModel)]="onChainSettlementEth"
          placeholder="0"
          step="0.001"
          min="0" />
        <p class="field-hint">Optional tip paid to whoever settles your bid against a listing.</p>
      </div>

      <div class="form-group">
        <label for="bid-amount">Bid Amount (Ξ)</label>
        <input 
          type="number" 
          id="bid-amount" 
          [(ngModel)]="collectionBidAmount" 
          placeholder="0" 
          step="0.001"
          min="0"
        />
      </div>

      <div class="form-actions">
        <button class="cancel" (click)="closeModal()">Cancel</button>
        <button 
          class="submit" 
          (click)="proceedFromAmountStep()"
          [class.disabled]="!collectionBidAmount || parseFloat(collectionBidAmount) <= 0">
          Continue
        </button>
      </div>
    </ng-container>

    <!-- Step 3: Transfer Confirmation -->
    <ng-container *ngIf="isActive && currentStep === 'transfer' && !(isTransactionActive && (txTrackingSvc.txModalActive$ | async))">
      <div class="punk-info">
        <p>You are about to transfer <strong>{{ collectionBidAmount }} ETH</strong> to your stash address.</p>
        <p>Stash address: <app-wallet-address [address]="stashAddress || ''"></app-wallet-address></p>
        <p class="warning">Please confirm the transaction in your wallet.</p>
      </div>

      <div class="form-actions">
        <button class="cancel" (click)="closeModal()">Cancel</button>
        <button class="submit" (click)="transferFundsToStash()">Transfer Funds</button>
      </div>
    </ng-container>

    <!-- Step 3: Sign message (stash) or on-chain tx -->
    <ng-container *ngIf="isActive && currentStep === 'sign' && !(isTransactionActive && (txTrackingSvc.txModalActive$ | async))">
      <div class="punk-info" *ngIf="isOnChainPlatformSelected">
        <p>
          Confirm the transaction in your wallet to place your
          <app-on-chain-bid-label>on-chain bid</app-on-chain-bid-label>.
        </p>

        <div class="bid-type-info">
          <p class="bid-type-label">Bid type: <strong>{{ getBidTypeLabel() }}</strong></p>

          <ng-container *ngIf="bidType === 'owner' && ownerAddress">
            <p style="margin: 1rem 0 0 0; padding: 0; font-size: 1.4rem;">
              Owner: <strong><app-wallet-address [address]="ownerAddress"></app-wallet-address></strong>
            </p>
            <p style="margin: 0.5rem 0 0 0; padding: 0; font-size: 1.4rem;">
              Punks count: <strong>{{ punkIndices.length }}</strong>
            </p>
          </ng-container>

          <ng-container *ngIf="bidType === 'targeted' && selectedPunkIds.length > 0">
            <p style="margin: 1rem 0 0 0; padding: 0; font-size: 1.4rem;">
              Selected punks: <strong>{{ selectedPunkIds.length }}</strong>
            </p>
            <ul class="traits-list" style="margin-top: 0.5rem;">
              <li *ngFor="let punkId of selectedPunkIds.slice(0, 10)">#{{ punkId }}</li>
              <li *ngIf="selectedPunkIds.length > 10">... and {{ selectedPunkIds.length - 10 }} more</li>
            </ul>
          </ng-container>

          <ng-container *ngIf="bidType === 'trait' && activeTraits.length > 0">
            <ul class="traits-list">
              <li *ngFor="let trait of activeTraits">{{ trait }}</li>
            </ul>
          </ng-container>
        </div>

        <p>Bid amount:&nbsp;<strong>{{ collectionBidAmount }} ETH</strong></p>
        <p *ngIf="showOnChainSettlementReward && parseFloat(onChainSettlementEth) > 0">
          Settlement reward:&nbsp;<strong>{{ onChainSettlementEth }} ETH</strong>
        </p>
      </div>

      <div class="punk-info" *ngIf="!isOnChainPlatformSelected">
        <p>Please sign the message to create your {{ getBidTypeLabel().toLowerCase() }}.</p>
        
        <!-- Bid type information -->
        <div class="bid-type-info">
          <p class="bid-type-label">Bid type: <strong>{{ getBidTypeLabel() }}</strong></p>
          
          <!-- Confidential bid info -->
          <p style="margin: 1rem 0 0 0; padding: 0; font-size: 1.4rem;">
            Confidential: <strong>{{ confidential ? 'Yes' : 'No' }}</strong>
          </p>
          
          <!-- Owner bid info -->
          <ng-container *ngIf="bidType === 'owner' && ownerAddress">
            <p style="margin: 1rem 0 0 0; padding: 0; font-size: 1.4rem;">
              Owner: <strong><app-wallet-address [address]="ownerAddress"></app-wallet-address></strong>
            </p>
            <p style="margin: 0.5rem 0 0 0; padding: 0; font-size: 1.4rem;">
              Punks count: <strong>{{ punkIndices.length }}</strong>
            </p>
          </ng-container>
          
          <!-- Targeted bid info -->
          <ng-container *ngIf="bidType === 'targeted' && selectedPunkIds.length > 0">
            <p style="margin: 1rem 0 0 0; padding: 0; font-size: 1.4rem;">
              Selected punks: <strong>{{ selectedPunkIds.length }}</strong>
            </p>
            <ul class="traits-list" style="margin-top: 0.5rem;">
              <li *ngFor="let punkId of selectedPunkIds.slice(0, 10)">#{{ punkId }}</li>
              <li *ngIf="selectedPunkIds.length > 10">... and {{ selectedPunkIds.length - 10 }} more</li>
            </ul>
          </ng-container>
          
          <!-- Trait bid info -->
          <ng-container *ngIf="bidType === 'trait' && activeTraits.length > 0">
            <ul class="traits-list">
              <li *ngFor="let trait of activeTraits">{{ trait }}</li>
            </ul>
          </ng-container>

          <p *ngIf="bidType === 'trait'" style="margin: 1rem 0 0 0; padding: 0; font-size: 1.4rem;">
            Disguise as custom bid: <strong>{{ disguiseTraitBidAsCustom ? 'Yes' : 'No' }}</strong>
          </p>
        </div>

        <p>Bid amount:&nbsp;<strong>{{ collectionBidAmount }} ETH</strong></p>
      </div>

      <div class="form-actions">
        <button class="cancel" (click)="closeModal()">Cancel</button>
        <button
          *ngIf="isOnChainPlatformSelected"
          class="submit"
          (click)="submitOnChainBid()"
          [class.disabled]="onChainBidSubmitting || !collectionBidAmount || parseFloat(collectionBidAmount) <= 0">
          {{ onChainBidSubmitting ? 'Submitting…' : 'Submit transaction' }}
        </button>
        <button
          *ngIf="!isOnChainPlatformSelected"
          class="submit"
          (click)="signPunkBidMessage()">
          Sign Message
        </button>
      </div>
    </ng-container>

    <!-- Step 4: Publish confirmation (stash) or on-chain success -->
    <ng-container *ngIf="isActive && currentStep === 'publish'">
      <ng-container *ngIf="onChainBidPlacedSuccessfully">
        <div class="punk-info">
          <p class="success-icon" aria-hidden="true">✓</p>
          <p>Your <app-on-chain-bid-label>on-chain bid</app-on-chain-bid-label> is live.</p>
          <p>
            <strong>{{ collectionBidAmount }} ETH</strong> escrowed for your {{ getBidTypeLabel().toLowerCase() }}.
          </p>
          <p *ngIf="showOnChainSettlementReward && parseFloat(onChainSettlementEth) > 0">
            Settlement reward: <strong>{{ onChainSettlementEth }} ETH</strong>
          </p>
          <p *ngIf="placedOnChainTxShortHash as txShort">
            Transaction:
            <a
              [href]="'https://etherscan.io/tx/' + placedOnChainTxHash"
              target="_blank"
              rel="noopener noreferrer">{{ txShort }}</a>
          </p>
        </div>

        <div class="form-actions">
          <button type="button" class="submit form-actions__single" (click)="closeModal()">Done</button>
        </div>
      </ng-container>

      <ng-container *ngIf="!onChainBidPlacedSuccessfully">
      <div class="punk-info">
        <p>Publishing your bid to the following platforms:</p>
      </div>

      <div class="publish-status-list">
        <!-- Shared listings orderbook (V1: v1cryptopunks.com, V2: cryptopunks.eth.limo) -->
        <div class="publish-status-item">
          <span class="platform-name">
            <a
              *ngIf="environment.collection === 'cryptopunks-v1'"
              href="https://v1cryptopunks.com"
              target="_blank"
              rel="noopener noreferrer">v1cryptopunks.com</a>
            <a
              *ngIf="environment.collection !== 'cryptopunks-v1'"
              href="https://cryptopunks.eth.limo"
              target="_blank"
              rel="noopener noreferrer">cryptopunks.eth.limo</a>
          </span>
          <span class="platform-status">
            <img
              *ngIf="publishStatusLimo === 'loading'"
              src="/assets/loader-{{ themeSvc.theme$ | async }}.gif"
              width="20" height="20"
              alt="Loading" />
            <span *ngIf="publishStatusLimo === 'success'" class="status-success">✅</span>
            <span
              *ngIf="publishStatusLimo === 'skipped'"
              class="status-skipped"
              tippy
              [options]="{ content: (environment.collection === 'cryptopunks-v1' ? 'Public bids are not added to the v1cryptopunks.com orderbook.' : 'Public bids are not added to the cryptopunks.eth.limo orderbook.'), placement: 'top', theme: 'punks' }">—</span>
            <span
              *ngIf="publishStatusLimo === 'error'"
              class="status-error"
              tippy
              [options]="{ content: publishErrorLimo, placement: 'top', theme: 'punks' }">❌</span>
          </span>
        </div>

        <!-- cryptopunks.app (optional) -->
        <div class="publish-status-item" *ngIf="showCryptopunksAppPublish">
          <span class="platform-name">
            <a href="https://www.cryptopunks.app" target="_blank" rel="noopener noreferrer">cryptopunks.app</a>
          </span>
          <span class="platform-status-actions">
            <span class="platform-status">
              <img
                *ngIf="publishStatusApp === 'loading'"
                src="/assets/loader-{{ themeSvc.theme$ | async }}.gif"
                width="20" height="20"
                alt="Loading" />
              <span *ngIf="publishStatusApp === 'success'" class="status-success">✅</span>
              <span
                *ngIf="publishStatusApp === 'error'"
                class="status-error"
                tippy
                [options]="{ content: publishErrorApp, placement: 'top', theme: 'punks' }">❌</span>
            </span>
            <button
              *ngIf="publishStatusApp === 'error'"
              class="retry-btn"
              (click)="retryCryptopunksAppPublish()">Retry</button>
          </span>
        </div>
      </div>

      <p *ngIf="showCryptopunksAppPublish" class="publish-hint">
        Publishing to cryptopunks.app may take a moment, please wait before closing this window.
      </p>
      </ng-container>
    </ng-container>
  </div>
</div>

<app-disguise-bid-confirmation-modal
  [isActive]="disguiseBidConfirmationActive"
  (confirmed)="onDisguiseBidConfirmationConfirm()"
  (cancelled)="onDisguiseBidConfirmationCancel()">
</app-disguise-bid-confirmation-modal>

